import { apiClient } from '@/lib/apiClient';

export interface AssistantRequest {
  message: string;
  conversationId?: string;
}

export interface AssistantContextualRequest extends AssistantRequest {
  entityType?: string;
  entityId?: string;
  currentState?: string;
  module?: string;
}

export interface ToolInvocation {
  toolName: string;
  input: string;
  output: string;
  durationMs: number;
}

export interface AssistantResponse {
  conversationId: string;
  text: string;
  toolsUsed: ToolInvocation[];
}

/** Whether the caller's roles give them an assistant. */
export interface AssistantAvailability {
  available: boolean;
}

// An assistant turn runs an LLM with several graph-tool rounds and routinely
// exceeds apiClient's 30s fail-fast default (which is sized for CRUD calls).
const ASSISTANT_TIMEOUT_MS = 120_000;

export const assistantApi = {
  async ask(request: AssistantRequest): Promise<AssistantResponse> {
    const response = await apiClient.post<AssistantResponse>('/api/assistant/ask', request, {
      timeout: ASSISTANT_TIMEOUT_MS,
    });
    return response.data;
  },

  async askInContext(request: AssistantContextualRequest): Promise<AssistantResponse> {
    const response = await apiClient.post<AssistantResponse>('/api/assistant/ask-in-context', request, {
      timeout: ASSISTANT_TIMEOUT_MS,
    });
    return response.data;
  },

  async availability(): Promise<AssistantAvailability> {
    const response = await apiClient.get<AssistantAvailability>('/api/assistant/availability');
    return response.data;
  },
};
